<template>
  <div class="kt-notes">
    <div class="container" v-if="!itineraryDays">
      <div class="row justify-content-center">
        <div class="col-6">
          <div class="kt-portlet kt-portlet--mobile mt-5">
            <div class="kt-portlet__body text-center my-5">
              <h3 class="mb-4">Sorry we don't have any day to show you.</h3>
              <a
                href="#"
                class="btn btn-md text-danger"
                @click.prevent="addDay"
              >
                <font-awesome-icon
                  class="mr-1"
                  :icon="['fas', 'plus-circle']"
                />Add a new day
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isReorderingDays">
      <TabItineraryReorder
        :days="itineraryDaysForReorder"
        :daySelected="reorderDaySelected"
        @onCancelReorder="onCancelReorder"
        @onSaveReorder="onSaveReorder"
      />
    </div>

    <SourceTypeNavigation
      v-if="!isReorderingDays"
      :sourceTypes="sourceTypes"
      :itinerarySourceTypeSelected="itinerarySourceTypeSelected"
      @onSelectTab="selectTab"
    />

    <div class="kt-notes__items" v-if="!isReorderingDays">
      <TabItineraryItemHeader
        v-if="
          itinerarySourceTypeSelected.text ===
            getItinerarySourceTypeById('ITP-FLYER').text
        "
      >
        <template slot="icon">
          <svg class="svg-icon cart_icon" viewBox="0 0 54 54">
            <path
              class="st0"
              d="M47.7 30.5c-.4.1-.9.3-1.3.3s-.6.1-.7.5c-1 3.7-2 7.5-3 11.2-.3 1.3-.7 2.6-1.1 3.9-.5 1.6-1.8 2.6-3.4 2.6H16c-1.7 0-3-1-3.4-2.6-1.1-4.1-2.2-8.1-3.3-12.2-.3-1-.5-2-.8-3-.1-.3-.2-.4-.5-.3h-.5c-.8 0-1.4-.6-1.4-1.4v-2.1c0-.9.6-1.4 1.5-1.4h6.3v-.8-7.4c0-2.2 1.4-3.7 3.7-3.7h1.2v-1.2c0-.3.1-.6.3-.8.5-.6 1-1.1 1.6-1.6.1-.1.2-.4.2-.5V8c0-.6.2-.8.8-.8h11.5c.8-.2 1 .1 1 .8v6.1h2.4c.6 0 1.3.1 1.8.3 1.4.6 2.1 1.7 2.1 3.2v8.3h5.7c.5 0 1 .2 1.5.3v4.3zm-3.2.3H10l.3 1.2c1.2 4.6 2.5 9.2 3.7 13.8.3 1.2 1 1.8 2.3 1.8h21.9c.2 0 .5 0 .7-.1.9-.3 1.4-.9 1.6-1.8 1-3.7 2-7.5 3-11.2.3-1.3.6-2.4 1-3.7zM34.3 18.3c0 .1-.1.1-.1.2-.4 1.7-1.8 2.3-3.3 1.5-.1-.1-.4 0-.5 0-.7.4-1.5.4-2.2 0-.3-.2-.4-.1-.6 0-.7.4-1.5.4-2.2 0-.3-.2-.4-.1-.6 0-1.2.7-2.6.2-3.1-1.1-.1-.2-.1-.4-.1-.6h-3.4v7.6h18.1v-7.6h-2zm-2.9-2.1v2.1c0 .4.3.7.7.7.4 0 .6-.3.7-.7V18 9.6v-1H22.3v.5c.2 1.3-.2 2.3-1.3 3.1l-.3.3c-.6.4-.5 1-.4 1.6h1.8c.7 0 .9.2.9.9v3.1c0 .4.2.7.6.8.4.1.8-.3.8-.8v-2h1.4v2.1c0 .4.3.7.7.7.4 0 .7-.2.7-.6v-.6-1.5h1.4v1.9c0 .5.3.9.7.9.4 0 .7-.3.7-.9v-1.9h1.4zM7.7 29.4h39v-2h-39v2zm9-3.5v-.5-7.6c0-.7.2-.9.9-.9h3.9v-1.3h-4c-1.3 0-2.2.9-2.2 2.2V26c.5-.1 1-.1 1.4-.1zm22.3 0v-.1-8.3c0-1-.7-1.9-1.7-2-1-.1-2.1 0-3.1 0v1.3h2.4c.8 0 1 .2 1 1v8c.6.1 1 .1 1.4.1z"
            />
            <path
              class="st0"
              d="M27.3 36.5c.2-.2.3-.4.5-.6 1.2-1.2 2.9-1.3 4.2-.1 1.2 1.1 1.3 3.1.2 4.3-1.4 1.5-2.8 2.9-4.2 4.4-.4.4-.8.4-1.2 0-1.4-1.4-2.8-2.9-4.2-4.3-1.1-1.2-1-3.2.1-4.3 1.2-1.2 2.9-1.1 4.2.1 0 .1.1.3.4.5zm-.2 6.4c.9-.8 1.8-1.6 2.6-2.4.5-.4.9-.9 1.3-1.4.6-.7.6-1.7-.1-2.3-.6-.6-1.5-.6-2.2.1l-.9.9c-.4.4-.8.4-1.1 0-.3-.3-.6-.7-.9-1-.7-.6-1.5-.7-2.1-.1-.6.6-.8 1.6-.2 2.2 1.1 1.5 2.4 2.8 3.6 4zM20.9 42v2H23v1.4h-2.9c-.2 0-.5-.4-.5-.6-.1-.9 0-1.8 0-2.8h1.3zM34.2 34.3h-2.1v-1.4H35c.2 0 .5.4.6.6.1.9 0 1.9 0 2.8h-1.4v-2zM13.9 33.6h-1.4v-1.3h1.4v1.3zM16.7 32.2v1.3h-1.3v-1.3h1.3zM18.2 33.6v-1.3h1.3v1.3h-1.3z"
            />
          </svg>
        </template>
        <template slot="content">
          Your are working in the itinerary for
          <span class="alert-warning px-1">Sales Flyer(PDF)</span> and
          <span class="alert-warning px-1">Landing Page</span>.

          <FlyerPreviewButton :on-loaded="(data) => pdfData = data" style="float: right;" />
        </template>
      </TabItineraryItemHeader>

      <TabItineraryItemHeader
        v-if="
          itinerarySourceTypeSelected.text ===
            getItinerarySourceTypeById('ITP-GUEST').text
        "
      >
        <template slot="icon">
          <svg class="svg-icon cart_icon" viewBox="0 0 54 54">
            <path
              class="st0"
              d="M36.3 26c.1-4.9-2.3-8.1-6.7-10.1 1-.9 1.6-2.2 1.5-3.6-.1-1.3-.6-2.4-1.5-3.2-1.9-1.5-4.4-1.5-6.1.2-1.6 1.6-2 4.4.1 6.5-4.4 1.9-6.7 5.1-6.7 10.1H7.4c-1.5 0-2.6.6-3.4 1.9-.4.6-.5 1.3-.5 2V46c0 1.1.3 2.1 1.1 2.8.6.8 1.5 1.2 2.6 1.2h38.9c1.4 0 2.5-.6 3.2-1.7.4-.5.6-1.3.6-1.9 0-5.5.1-11.1 0-16.6 0-1.4-.7-2.6-2.1-3.3-.7-.3-1.4-.5-2.1-.5h-9.4zM10.9 45.5V30.6h7c.1 0 .4 0 .4.1.2.4.4.9.5 1.4h-6.5V44h14.9V32.1H24.5c-.1 0-.3 0-.3-.1-.2-.5-.4-.9-.5-1.4h15.5v14.9H10.9zm11.6-18h19.8v20.9H7.1c-1.2 0-2.3-1-2.2-2.2.1-1.1 0-2.3 0-3.4v-.4h.6c1.3.1 2.4-1 2.4-2.3-.1-1.5-.1-2.9 0-4.4 0-.9-.8-2.1-1.7-2.2-.4-.1-.8-.1-1.2-.2v-3.6c-.1-1.3 1.1-2.3 2.4-2.3h9.9c.2.5.3 1 .5 1.5h-6.7c-.8 0-1.6.8-1.6 1.6.1 1.3 0 2.5 0 3.8v11.1c0 .2.1.5.2.7.4.6.9.9 1.6.9h28c.4 0 .8-.2 1.1-.4.5-.4.5-.9.5-1.4V30.6c0-.8-.8-1.6-1.6-1.6H23.6c-.1 0-.3 0-.4-.1-.3-.4-.5-.9-.7-1.4zm12.4-1.6h-2.3v-3.7h-1.4V25.4c0 .4-.1.5-.5.5h-8.3l.6-3.6-1.5-.3c-.2 1.1-.3 2.2-.5 3.2 0 .1-.1.2-.1.4-.1.5-.3 1 0 1.6.3.6.5 1.3.8 1.9.3.6.6 1.2.8 1.8.2.5.6 1 .5 1.7-.1.3-.4.7-.8.8-.5 0-.9-.1-1.1-.5-.4-1.1-.8-2.1-1.3-3.2-.1-.3-.3-.7-.4-1-.2-.6-.6-1.3-.7-1.9-.4-1.9-.1-3.7.8-5.4.6-1.2 1.5-2.2 2.6-3 1.1-.8 2.4-1.3 3.8-1.4 1.4-.1 2.7 0 4 .6.8.4 1.6.8 2.2 1.4.7.6 1.3 1.3 1.7 2.2.3.5.5 1.1.7 1.6.3 1.1.4 2.1.4 3.1zm-9 16.5h-12v-9h5.3c.1 0 .3.1.4.2.2.4.6.7 1 1 1.1.6 2.4.3 3.1-.6.4-.5.7-.8 1.4-.7h.3c.5 0 .5 0 .5.5v8.6zm17.9 6V27.5h2.1c1.4 0 2.4 1 2.4 2.4v16c0 .4-.1.8-.2 1.2-.2.7-.8 1.2-1.5 1.3h-2.8zM26.6 15.5c-1.5 0-2.9-1.3-3-2.9-.1-1.8 1.3-3.1 2.9-3.1 1.7 0 3 1.3 3 2.8.2 1.8-1.2 3.2-2.9 3.2zM5 35h.7c.4 0 .7.3.7.7v4.6c0 .3-.2.6-.5.6H5V35z"
            />
            <path
              class="st0"
              d="M28.8 42.5h9v-1.3c0-.1-.2-.2-.3-.2h-8.2c-.3 0-.4.1-.4.4-.1.3-.1.6-.1 1.1zM28.8 35v1.4h9V35h-9zM28.8 32.1v1.4h9v-1.4h-9zM31.9 38v1.5h5.9V38h-5.9zM28.8 38v1.5h1.5V38h-1.5zM46.8 35h-1.5v5.9h1.5V35z"
            />
          </svg>
        </template>
        <template slot="content">
          Your are working in the itinerary for
          <span class="alert-warning px-1">Guest Documentation</span>.
        </template>
      </TabItineraryItemHeader>

      <PDFViewer v-if="pdfData" :data="pdfData" />
      <div v-else>
        <TabItineraryItem
          v-for="(day, index) in itineraryDays"
          :key="index"
          :data="day"
          :order="index"
          :isCompletedQuote="isCompletedQuote"
          :isHighlighted="selectedDay && selectedDay.order === index"
          :itinerarySourceTypeSelected="itinerarySourceTypeSelected"
          :showAddANewDayAbove="
            index === 0 && itinerarySourceTypeSelected.index > 0
          "
          @onSaveLikeATemplate="onSaveLikeATemplate"
          @onfillDay="onfillDay"
          @onDeleteDay="onDeleteDay"
          @onReorderDay="onReorderDay"
          ref="itineraryItem"
          class="TabItineraryItemSection"
        />
        <div class="kt-notes__item">&nbsp;</div>
      </div>

      <Portal to="deletePortal">
        <Modal :show="isModalShow" @close="onCloseModalCustom">
          <div class="text-center mb-4" v-if="currentModal === 'delete_day'">
            <font-awesome-icon
              class="text-warning"
              :icon="['fas', 'trash-alt']"
              size="4x"
            />
            <h1 class="text-info text-center my-4">Delete day</h1>
            <p class="lead mb-5">
              Hi! Do you want to permanently delete this module?
            </p>
            <button
              class="btn btn-wide btn-light btn--cancel mr-1 font-weight-bold"
              :disabled="isDeleting"
              @click="onCloseModalCustom"
            >
              No, thanks
            </button>
            <button
              class="btn btn-wide btn-info ml-1 font-weight-bold"
              @click="deleteDay(selectedDay)"
              :disabled="isDeleting"
            >
              <span v-if="!isDeleting">Yes, please delete it</span>
              <span v-if="isDeleting">
                <font-awesome-icon
                  class="text-white"
                  :icon="['fas', 'spinner']"
                  spin
                />
              </span>
            </button>
          </div>
          <div
            class="text-center mb-4"
            v-if="currentModal === 'complete_quote_alert'"
          >
            <font-awesome-icon
              class="text-danger"
              :icon="['fas', 'ban']"
              size="4x"
            />
            <p class="lead mb-5 my-4">
              It is not posible to display his version. The quote has be
              completed (Sales Quote Sent) to see it.
            </p>
            <button
              class="btn btn-wide btn-light btn--cancel mr-1 font-weight-bold"
              @click="onCloseModalCustom"
            >
              Take me back
            </button>
            <button
              class="btn btn-wide btn-info ml-1 font-weight-bold"
              @click="handleSelectTab(tabs.TAB_SHARE)"
            >
              Go to Complete Quote
            </button>
          </div>
        </Modal>
      </Portal>
      <Sidebar
        :show="isSidebarShow"
        @close="onCloseSidebarCustom"
        :width="currentSidebarWidth"
      >
        <div class="px-0" v-if="currentSidebar === 'fillDaySidebar'">
          <h2 class="text-left border-bottom px-3 pt-2 pb-4 text-info">
            Fill a day
          </h2>

          <div class="container-fluid mt-3 px-4 py-4">
            <TabItinerarySearchForm
              :brands="brands"
              :themes="themes"
              @onSearch="search"
              @onReset="reset"
              :isSearching="isSearching"
            />
          </div>

          <div class="container-fluid px-4">
            <div class="position-relative column">
              <div
                class="font-weight-normal bg-info text-white px-4 py-0 column--result"
              >
                Results:&nbsp;
                <span v-if="!isSearching">{{ total }}</span>
                <font-awesome-icon
                  v-else
                  class="text-white"
                  :icon="['fas', 'spinner']"
                  spin
                />
              </div>
              <div class="toolbar-actions">
                <a
                  class="btn btn-transparent btn-elevate-hover btn-sm btn-icon"
                  href=""
                  @click.prevent="toggleList1"
                >
                  <font-awesome-icon
                    :icon="['fas', 'compress-arrows-alt']"
                    v-if="!collapseAllList1"
                  />
                  <font-awesome-icon
                    :icon="['fas', 'expand-arrows-alt']"
                    v-if="collapseAllList1"
                  />
                </a>
              </div>

              <div class="bg-light DraggableBox" v-if="myArray1.length === 0">
                <AlertMessage>
                  <font-awesome-icon
                    class="kt-label-font-color-1"
                    :icon="['fas', 'search']"
                    size="3x"
                    v-if="!isSearching"
                  />
                  <font-awesome-icon
                    class="kt-label-font-color-1"
                    :icon="['fas', 'spinner']"
                    size="3x"
                    spin
                    v-if="isSearching"
                  />
                  <h3
                    class="kt-callout__title kt-label-font-color-1 mt-3"
                    v-if="!isSearching && !isNotFound"
                  >
                    Use the filters to see results...
                  </h3>
                  <h3
                    class="kt-callout__title kt-label-font-color-1 mt-3"
                    v-if="!isSearching && isNotFound"
                  >
                    Sorry! We didn't find results for your search.<br /><small
                      >We have filtered according to your office, type of
                      opportunity, brand(s) and keywords.</small
                    >
                  </h3>
                  <p class="kt-callout__desc"></p>
                </AlertMessage>
              </div>
              <div v-else class="bg-light DraggableBox">
                <ResultsBox
                  v-for="element in myArray1"
                  :key="element.id"
                  :data="element"
                  :isCollapsed="collapseAllList1"
                  :isSelectable="true"
                  :selected="resultBoxSelected"
                  @click.prevent="selectResultBox(element)"
                />
                <div class="text-center mt-3" slot="footer" key="footer">
                  <button
                    class="btn btn-wide btn-info btn-sm"
                    @click.prevent="loadMore"
                    :disabled="isSearching"
                    v-if="!isComplete"
                  >
                    <span v-if="!isSearching">Load more</span>
                    <font-awesome-icon
                      v-else
                      class="text-white"
                      :icon="['fas', 'spinner']"
                      spin
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="px-0" v-if="currentSidebar === 'saveLikeATemplateSidebar'">
          <SidebarSaveLikeATemplate
            :opportunityData="opportunityData"
            :selectedDay="selectedDay"
            :formats="templateFormats"
            :regions="opportunityDetails.regions"
            :brands="templateBrands"
            :themes="templateThemes"
            @onSaveTemplate="onSaveTemplate"
          />
        </div>
      </Sidebar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, minLength } from 'vuelidate/lib/validators'
import flatten from 'lodash/flatten'

import TabItineraryItem from '@/components/opportunity-edit/TabItineraryItem.vue'
import TabItineraryItemHeader from '@/components/opportunity-edit/TabItineraryItemHeader.vue'
import Modal from '@/components/_shared/Modal.vue'
import Sidebar from '@/components/_shared/Sidebar.vue'

import TabItinerarySearchForm from '@/components/opportunity-edit/TabItinerarySearchForm.vue'
import ResultsBox from '@/components/opportunity-select/ResultsBox.vue'
import AlertMessage from '@/components/opportunity-select/AlertMessage.vue'

import TabItineraryReorder from '@/components/opportunity-edit/TabItineraryReorder.vue'
import SidebarSaveLikeATemplate from '@/components/opportunity-edit/SidebarSaveLikeATemplate.vue'

import SourceTypeNavigation from '@/components/opportunity-edit/SourceTypeNavigation.vue'

import ModalMixin from '@/mixins/modal'
import SidebarMixin from '@/mixins/sidebar'
import PDFViewer from "@/components/_shared/PDFViewer.vue";
import FlyerPreviewButton from "@/components/opportunity-edit/FlyerPreviewButton.vue";

export default {
  name: 'TabItinerary',
  inject: ['$v'],
  mixins: [ModalMixin, SidebarMixin],
  components: {
    FlyerPreviewButton,
    PDFViewer,
    TabItineraryItem,
    TabItineraryItemHeader,
    TabItinerarySearchForm,
    ResultsBox,
    AlertMessage,
    TabItineraryReorder,
    SidebarSaveLikeATemplate,
    SourceTypeNavigation,
    Modal,
    Sidebar
  },
  data () {
    const sourceType = {
      ITP: 'ITP',
      ITP_FLYER: 'ITP-FLYER',
      ITP_GUEST: 'ITP-GUEST'
    }
    return {
      pdfData: '',
      collapseAllList1: false,
      selectedDay: null,
      brand: '',
      theme: '',
      keyword: '',
      isSearching: false,
      total: 0,
      myArray1: [],
      searchParams: null,
      isComplete: false,
      isNotFound: false,
      resultBoxSelected: null,
      isDeleting: false,
      isLoading: false,
      isReorderingDays: false,
      reorderDaySelected: null,
      currentSidebar: '',
      sourceType,
      currentModal: '',
      tabs: {
        TAB_SHARE: 'tab_share'
      }
    }
  },
  validations: {
    brand: { required },
    theme: {},
    keyword: { required, minLength: minLength(3) }
  },
  props: {
    isCompletedQuote: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    ...mapGetters({
      stepSelect: 'opportunity/stepSelect',
      itineraryDaysForReorder: 'opportunity/itineraryDaysForReorder',
      opportunityDetails: 'opportunity/opportunityDetails',
      formatTypes: 'opportunity/formatTypes',
      sourceTypes: 'opportunity/sourceTypes',
      opportunityData: 'opportunity/opportunity',
      itinerarySourceTypeSelected: 'opportunity/itinerarySourceTypeSelected',
      opportunitySource: 'opportunity/opportunitySource',
      existItineraryBySourceType: 'opportunity/existItineraryBySourceType',
      getItinerarySourceTypeById: 'opportunity/getItinerarySourceTypeById',
      getSourceTypeIndex: 'opportunity/getSourceTypeIndex'
    }),
    itineraryDays () {
      return this.opportunitySource.itineraries && this.opportunitySource.itineraries[this.itinerarySourceTypeSelected.index].days ? this.opportunitySource.itineraries[this.itinerarySourceTypeSelected.index].days : []
    },
    templateFormats () {
      return this.formatTypes
    },
    templateBrands () {
      return this.brands.slice(1)
    },
    templateThemes () {
      return this.themes.slice(1)
    },
    currentSidebarWidth () {
      let currentSidebarWidth = 600 // Default Sidebar Width
      if (this.currentSidebar === 'saveLikeATemplateSidebar') {
        return 500
      }
      return currentSidebarWidth
    },
    formats () {
      return this.formatTypes.slice(0, 2)
    },
    brands () {
      if (this.stepSelect) {
        return this.stepSelect.brands
      }
      return []
    },
    themes () {
      if (this.stepSelect) {
        return this.stepSelect.themes
      }
      return []
    }
  },
  methods: {
    cancelPreviewPDF () {
      this.pdfData = ''
    },
    onSaveTemplate () {
      this.isLoading = !this.isLoading
    },
    onCloseModalCustom () {
      this.selectedDay = null
      this.onCloseModal()
    },
    onCloseSidebarCustom () {
      if (!this.isLoading) {
        this.selectedDay = null
        this.currentSidebar = ''
        this.onCloseSidebar()
      }
    },
    toggleReorderBox () {
      this.isReorderingDays = !this.isReorderingDays
    },
    toggleList1 () {
      this.collapseAllList1 = !this.collapseAllList1
    },
    addDay () {
      const payload = {
        index: 0,
        day: {
          id: null,
          title: 'Day added',
          locations: [],
          textday: [{ textday: '' }],
          startdate: '',
          startday: 1,
          isANewDay: true
        }
      }

      this.$store.commit('opportunity/TEMP_ADD_DAY', payload)
      this.$store.commit('opportunity/TEMP_REFRESH_ORDER_DAYS', payload)
      this.$store.commit('opportunity/TEMP_REFRESH_DATE_DAYS', payload)

      this.scrollTo(this.order)
    },
    scrollTo (order) {
      this.$scrollTo(`#day_${order}`, { duration: 800, offset: -95 })
    },
    selectResultBox (resultBox) {
      this.resultBoxSelected = resultBox
      const oldId = this.selectedDay.data.id
      let id = oldId || this.resultBoxSelected.id
      if (this.selectedDay.data.isANewDay) {
        id = null
      }
      let payload = {
        index: this.selectedDay.order,
        day: {
          id,
          meals: this.resultBoxSelected.meals,
          title: this.resultBoxSelected.title,
          textday: this.resultBoxSelected.textday,
          duration: this.resultBoxSelected.duration,
          idimagen: this.resultBoxSelected.idimagen,
          startday: this.resultBoxSelected.startday,
          locations: this.resultBoxSelected.locations,
          accommodation: this.resultBoxSelected.accommodation,
          startdate: '',
          enddate: ''
        }
      }
      this.$store.commit('opportunity/TEMP_FILL_DAY', payload)
      this.$store
        .dispatch('opportunity/saveOpportunity')
        .then(response => {
          this.isLoading = false
          this.onCloseSidebarCustom()
          this.$notification.success('Day was filled successfully!')

          if (response.stateUpdated) return;

          this.$store
            .dispatch(
              'opportunity/getOpportunity',
              response.data.uuidOpportunity
            )
            .then(response => {
              // data.isANewDay
              // console.log('yellow', this.$refs.itineraryItem[payload.index])
              // quitar colo amarillo
            })
            .catch(error => {
              if (error.response && error.response.status > 400) {
                // 401 || 403
                // this.$store.dispatch('auth/removeToken')
              }
            })
        })
        .catch(error => {
          this.isLoading = false
          this.$notification.error('An error has ocurred!')
          this.onCloseSidebarCustom()
          if (error.response && error.response.status > 400) {
            // 401 || 403
            // this.$store.dispatch('auth/removeToken')
          }
        })
    },
    search (params) {
      const DAY_BY_DAY = this.formats[1].value

      // Addicional info: id_opportunity_export_type
      const editOpportunity = this.$v.editOpportunity.$model
      const opportunityDetailsType = Number(
        editOpportunity.opportunityDetailsTab.typeId
      )
      const opportunityDetailsRegionId = Number(
        editOpportunity.opportunityDetailsTab.regionId
      )
      params['id_opportunity_export_type'] = opportunityDetailsType
      params['regionId'] = opportunityDetailsRegionId

      this.isSearching = true
      this.reset()
      params.format = DAY_BY_DAY

      this.$store
        .dispatch('opportunity/searchOpportunity', params)
        .then(response => {
          const data = response.shift()
          if (data.total === 0) {
            this.total = 0
            this.isNotFound = true
            this.isSearching = false
            this.isComplete = false
            this.myArray1 = []
            this.numRows = 0
          } else {
            this.searchParams = params
            this.total = Number(data.total)
            // this.myArray1 = data._items
            const days = data._items.map(item => {
              return item.days.map(d => {
                return {
                  isADay: true,
                  itineraryCode: data._items[0].code,
                  itineraryTitle: data._items[0].title,
                  itineraryBrand: data._items[0].brand_name,
                  itineraryTheme: data._items[0].theme,
                  ...d
                }
              })
            })
            this.myArray1 = flatten(days)
            this.numRows = this.myArray1.length
            this.isSearching = false
            this.isNotFound = false
            this.isComplete = false
          }
        })
        .catch(() => {
          this.isSearching = false
          this.isNotFound = true
          this.numRows = 0
        })
    },
    loadMore () {
      this.searchParams.offset = this.numRows
      this.isSearching = true

      this.$store
        .dispatch('opportunity/searchOpportunity', this.searchParams)
        .then(response => {
          const data = response.shift()
          if (data._items) {
            this.total = Number(data.total)
            //
            const days = data._items.map(item => item.days)
            this.myArray1.push(...flatten(days))
            this.numRows = this.numRows + this.myArray1.length
            //
            this.isSearching = false
            this.isNotFound = false
          } else {
            this.isComplete = true
            this.isSearching = false
            this.isNotFound = false
          }
        })
        .catch(() => {
          this.isSearching = false
          this.isNotFound = true
        })
    },
    reset () {
      this.myArray1 = []
    },
    onSaveLikeATemplate (day) {
      this.selectedDay = day
      this.currentSidebar = 'saveLikeATemplateSidebar'
      this.onShowSidebar()
    },
    onfillDay (day) {
      this.selectedDay = day
      this.reset()
      this.resultBoxSelected = null
      this.total = 0
      this.currentSidebar = 'fillDaySidebar'
      this.onShowSidebar()
    },
    onDeleteDay (day) {
      this.currentModal = 'delete_day'
      this.selectedDay = day
      this.onShowModal()
    },
    onCompleteQuoteAlert () {
      this.currentModal = 'complete_quote_alert'
      this.onShowModal()
    },
    onReorderDay (day) {
      this.$store.commit('opportunity/TOGGLE_REORDERING_ITINERARY')
      this.toggleReorderBox()
      this.reorderDaySelected = day
    },
    async deleteDay (day) {
      try {
        this.isDeleting = true
        const payload = { indexDay: day.order, isANewDay: day.data.isANewDay }
        this.$store.commit('opportunity/TEMP_REMOVE_DAY', payload)
        const uuid = this.$route.params.privateId
        if (day.data.isANewDay) {
          this.isDeleting = false
          this.onCloseModalCustom()
          this.$refs.itineraryItem[day.order].toggleBox(false)
          this.$store.commit('opportunity/TEMP_REFRESH_ORDER_DAYS', payload)
          this.$store.commit('opportunity/TEMP_REFRESH_DATE_DAYS', payload)
          this.$store.dispatch('opportunity/saveOpportunityDataInLocalStorage', uuid)

          return true
        }

        const response = await this.$store.dispatch('opportunity/saveOpportunityDataInLocalStorage', uuid)
        if (response) {
          this.isDeleting = false
          this.onCloseModalCustom()
          this.$refs.itineraryItem[day.order].toggleBox(false)
          this.$refs.itineraryItem[day.order].slideDownDay()
          this.$notification.success('Day was deleted temporarily, when you finish editing the whole itinerary, please click the "Save" button located at the bottom.')
          this.$refs.itineraryItem[day.order].slideDownDay()
        }
        // this.$store
        //   .dispatch('opportunity/saveOpportunity')
        //   .then(response => {
        //     this.isDeleting = false
        //     this.onCloseModalCustom()
        //     this.$refs.itineraryItem[day.order].toggleBox()
        //     this.$refs.itineraryItem[day.order].slideDownDay()
        //     this.$notification.success('Day was deleted successfully!')
        //     this.$store
        //       .dispatch(
        //         'opportunity/getOpportunity',
        //         response.data.uuidOpportunity
        //       )
        //       .then(response => {
        //         this.$refs.itineraryItem[day.order].slideDownDay()
        //       })
        //       .catch(error => {
        //         if (error.response && error.response.status > 400) {
        //           // 401 || 403
        //           // this.$store.dispatch('auth/removeToken')
        //         }
        //       })
        //   })
        //   .catch(error => {
        //     this.isDeleting = false
        //     this.$notification.error('An error has ocurred!')
        //     this.onCloseModalCustom()
        //     if (error.response && error.response.status > 400) {
        //       // 401 || 403
        //       // this.$store.dispatch('auth/removeToken')
        //     }
        //   })
        this.$store.commit('opportunity/TEMP_REFRESH_ORDER_DAYS', payload)
        this.$store.commit('opportunity/TEMP_REFRESH_DATE_DAYS', payload)
      } catch (error) {
        console.info(error)
        this.isDeleting = false
        this.$notification.error('An error has ocurred!')
        this.onCloseModalCustom()
      }
    },
    onCancelReorder () {
      this.toggleReorderBox()
      this.$store.commit('opportunity/TOGGLE_REORDERING_ITINERARY')
    },
    async onSaveReorder (newOrder) {
      try {
        this.$store.commit('opportunity/TEMP_REORDER_ITINERARY', newOrder)

        const uuid = this.$route.params.privateId
        const response = await this.$store
          .dispatch('opportunity/saveOpportunityDataInLocalStorage', uuid)
        if (response) {
          this.isEditing = false
          this.isSaving = false
          this.$notification.success('Days was re-ordered temporarily, when you finish editing the whole itinerary, please click the "Save" button located at the bottom.')
          this.toggleReorderBox()
          this.$store.commit('opportunity/TOGGLE_REORDERING_ITINERARY')
        }
        // this.$store
        //   .dispatch('opportunity/saveOpportunity')
        //   .then(response => {
        //     this.$notification.success('Days was re-ordered successfully!')
        //     this.toggleReorderBox()
        //     this.$store.commit('opportunity/TOGGLE_REORDERING_ITINERARY')
        //     this.$store
        //       .dispatch(
        //         'opportunity/getOpportunity',
        //         response.data.uuidOpportunity
        //       )
        //       .then(response => {})
        //       .catch(error => {
        //         if (error.response && error.response.status > 400) {
        //           // 401 || 403
        //           // this.$store.dispatch('auth/removeToken')
        //         }
        //       })
        //   })
        //   .catch(error => {
        //     console.log(error)
        //     this.$notification.error('An error has ocurred!')
        //   })
      } catch (error) {
        console.info(error)
        this.$notification.error('An error has ocurred!')
      }
    },
    selectTab (sourceType) {
      this.cancelPreviewPDF()
      const indexItinerary = this.existItineraryBySourceType(sourceType.value)
      if (indexItinerary < 0) {
        this.onCompleteQuoteAlert()
      } else {
        this.$store.commit('opportunity/SET_SOURCE_TYPE_SELECTED', {
          sourceType,
          indexItinerary
        })
      }
    },
    handleSelectTab (tabName) {
      this.onCloseModalCustom()
      this.$emit('onSelectTab', tabName)
    }
  }
}
</script>

<style lang="scss" scoped>
.column {
  height: calc(100vh - 260px);
}
.column--result {
  position: absolute;
  font-weight: 500 !important;
  top: -10px;
  left: -0.5px;
  padding: 1px 10px !important;
  border-radius: 3px;
  z-index: 2;
}
.toolbar-actions {
  position: absolute;
  top: -28px;
  right: -12px;
  z-index: 2;
  padding: 0px 4px;
}
.DraggableBox {
  overflow-y: scroll;
  padding: 15px 10px;
  height: calc(100% - 0px);
  box-shadow: 0 0 2px #ccc;
  z-index: 1;
}
.cart_icon .st0 {
  fill: #fff;
}
.kt-badge--beta {
  background-color: #989898 !important;
  color: white;
}
</style>
